import { ErrorType, LoadedType, RequestType } from 'common/actions/freshdeskSettings';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
